import { createAsyncThunk } from '@reduxjs/toolkit'

import { apiGET } from '../../lib/api'
import { BusDriverSignOn } from '../../types/Input'

type FetchBusDriverSignOnsError = {
  message: string
}

type FetchBusDriverSignOnsAllowedResponse =
  | boolean
  | string
  | {
      busDriverSignOnsAllowed?: boolean
    }

const fetchBusDriverSignOns = (): Promise<BusDriverSignOn[]> => apiGET('/bus-driver/sign-ons')
const fetchBusDriverSignOnsAllowed = (): Promise<FetchBusDriverSignOnsAllowedResponse> =>
  apiGET('/bus-driver/sign-ons/allowed')

const parseBusDriverSignOnsAllowed = (response: FetchBusDriverSignOnsAllowedResponse) => {
  if (typeof response === 'boolean') {
    return response
  }

  if (typeof response === 'string') {
    return response === 'true'
  }

  return response.busDriverSignOnsAllowed === true
}

export const fetchBusDriverSignOnsAllowedAction = createAsyncThunk<boolean>(
  'bus-driver-sign-ons/fetchBusDriverSignOnsAllowed',
  async () => {
    try {
      return parseBusDriverSignOnsAllowed(await fetchBusDriverSignOnsAllowed())
    } catch {
      return false
    }
  }
)

export const fetchBusDriverSignOnsAction = createAsyncThunk<
  BusDriverSignOn[],
  void,
  { rejectValue: FetchBusDriverSignOnsError }
>('bus-driver-sign-ons/fetchBusDriverSignOns', async (_, thunkApi) => {
  try {
    return await fetchBusDriverSignOns()
  } catch (err) {
    return thunkApi.rejectWithValue({
      message: 'Failed to fetch bus driver sign-ons',
    })
  }
})
